module.exports = __webpack_public_path__ + "img/pagination-waterSavingsActivated.e1c3e079.svg";